import { render, staticRenderFns } from "./color-info.vue?vue&type=template&id=2eb9d04c"
import script from "./color-info.vue?vue&type=script&lang=js"
export * from "./color-info.vue?vue&type=script&lang=js"
import style0 from "./color-info.vue?vue&type=style&index=0&id=2eb9d04c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports